module.exports = __webpack_public_path__ + "static/media/masterportfolio-banner-light.46ae2651.png";